import { render, staticRenderFns } from "./HouseIcon.vue?vue&type=template&id=972ddfd6&scoped=true&"
var script = {}
import style0 from "./HouseIcon.vue?vue&type=style&index=0&id=972ddfd6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "972ddfd6",
  null
  
)

export default component.exports